<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <!-- <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container> -->
      <zj-layout-container class="content video-monitor">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            视频回放
            <div class="title_btmLine"></div>
          </div>
          <el-input
            placeholder="搜索监控点"
            class="nav-tree-filter"
            v-model="filterText"
          ></el-input>
          <div class="nav-tree-content" style="height:60%;overflow:auto;">
            <el-tree
              style="height:100%;"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="tree"
              node-key="id"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
          <div style="margin-top:20px;">
            <el-form
              ref="playbackForm"
              :model="ruleForm"
              :rules="rules"
              :inline="true"
              style="margin-bottom:15px;"
            >
              <el-form-item
                style="padding-left:0px;margin-right:0px;margin-bottom:0px;"
                prop="date1"
              >
                <el-date-picker
                  class="dateOutline"
                  v-model="ruleForm.date1"
                  type="datetime"
                  placeholder="请选择开始日期时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                style="padding-left:0px;margin-right:0px;margin-bottom:0px;"
                prop="date2"
              >
                <el-date-picker
                  class="dateOutline"
                  style="margin-top:20px;"
                  v-model="ruleForm.date2"
                  type="datetime"
                  placeholder="请选择结束日期时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item style="margin-top:20px;margin-right:0px;padding:0;">
                <div style="display:flex;justify-content: space-between;">
                  <el-button
                    class="searchBtn"
                    type="primary"
                    @click="onPlayback()"
                    >搜索</el-button
                  >
                  <el-button
                    class="resetBtn"
                    type="primary"
                    @click="resetForm()"
                    >重置</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
            <!-- <el-date-picker
              v-model="playbackTimeRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker> -->
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox" v-if="showtype == '1'">
              <div class="showOneVideo">
                <div style="width:100%;height:100%;">
                  <div style="width:100%;height:100%;">
                    <ZjCameraPlayback
                      ref="childOneVideo"
                      :cameraId="cameras[0].cameraId"
                      :cameraName="cameras[0].cameraName"
                      :streamType="playbackPlayerConfigs.streamType"
                      :autoplay="playbackPlayerConfigs.autoplay"
                      :beginTime="ruleForm.date1"
                      :endTime="ruleForm.date2"
                      style="width:100%; height:100%;"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 分屏是一个的时候结束 -->
            <!-- 分屏是3个 -->
            <!-- <VideoMonitorThree  v-if="showtype=='3'"></VideoMonitorThree> -->
            <div class="threes" v-if="showtype == '3'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo">
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>
            <!-- 分屏是3个结束 -->
            <!-- 分屏是4个，第一种开始&&showtypeIndex=='2' -->
            <div class="threes averaBox" v-if="showtype == '4'">
              <template v-for="(item, index) in cameras">
                <div
                  class="righttopvideo"
                  :key="index"
                  :class="{ martop12: index > 1 }"
                >
                  <ZjCameraPlayback
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :streamType="playbackPlayerConfigs.streamType"
                    :autoplay="playbackPlayerConfigs.autoplay"
                    :beginTime="ruleForm.date1"
                    :endTime="ruleForm.date2"
                    style="width:100%; height:100%;"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是4个，第一种结束 -->
            <!-- 分屏是4个，第二种开始 -->
            <div class="threes" v-if="showtype == '4' && showtypeIndex == '3'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo">
                <div class="rightvideo3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div
                  class="rightvideo3"
                  style="margin-top:10px;margin-bottom:10px;"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div class="rightvideo3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[3].cameraId"
                    :cameraName="cameras[3].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>
            <!-- 分屏是4个，第二种结束 -->
            <!-- 分屏是6个，第1种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '4'"
            >
              <div
                class="videoSix"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
            </div>
            <!-- 分屏是6个，第1种结束 -->
            <!-- 分屏是6个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '5'"
            >
              <div
                class="videoSixtop"
                :class="{ videoSixtop: index < 2, videoSixbottom: index > 1 }"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
            </div>
            <!-- 分屏是6个，第二种结束 -->
            <!-- 分屏是7个 -->
            <div class="threes averaBox" v-if="showtype == '7'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index != 0" :key="index">
                    <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    />
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是7个结束 -->
            <!-- 分屏是9个 第一种开始 &&showtypeIndex=='7'-->
            <div class="threes averaBox" v-if="showtype == '9'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :key="index">
                  <ZjCameraPlayback
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :streamType="playbackPlayerConfigs.streamType"
                    :autoplay="playbackPlayerConfigs.autoplay"
                    :beginTime="ruleForm.date1"
                    :endTime="ruleForm.date2"
                    style="width:100%; height:100%;"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是9个 第一种结束-->
            <!-- 分屏是9个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '8'"
            >
              <div
                class="leftBigVideo"
                style="border:none !important;display:flex;flex-wrap:wrap;justify-content: space-between;"
              >
                <div
                  class="videoSixtop"
                  :class="{
                    videoNinetop: index == 0,
                    videoNinebottom: index == 1 || index == 2,
                  }"
                  v-for="(item, index) in cameras"
                  :key="index"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div class="rightvideo7" v-if="index > 2" :key="index">
                    <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    />
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是9个，第二种结束 -->
            <!-- 分屏是12个 第一种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '9'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第一种结束-->
            <!-- 分屏是12个 第二种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '10'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第二种结束-->
            <!-- 分屏是15个 第1种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '11'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo15"
                  :key="index"
                  :class="{ martop12: index > 4 }"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第1种结束-->
            <!-- 分屏是15个 第2种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '12'"
            >
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :key="index" v-if="index < 3">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div
                  class="rightvideomini"
                  :key="index"
                  :class="{ martop12: index > 2 }"
                  v-if="index > 2"
                >
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第2种结束-->
            <!-- 分屏是16个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '16'">
              <template v-for="(item, index) in cameras">
                <!-- :class="{'martop12':index>3}" -->
                <div class="rightvideo16" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是16个 第1种结束-->
            <!-- 分屏是24个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '24'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo24" :key="index">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是24个 第1种结束-->
          </div>
          <div class="bottomContent">
            <!-- 左侧单个视频控制播放 -->
            <div class="changebofang" v-if="cameras.length == 1">
              <div style="width:19px;height:21px;" @click="startOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/zanting.png"
                  alt=""
                />
              </div>
              <div class="line"></div>
              <div style="width:21px;height:21px;" @click="stopOneVideo">
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/tingzhi.png"
                  alt=""
                />
              </div>
            </div>
            <!-- 右侧分屏数量 -->
            <div class="rightChange">
              <div class="changeLogo" @click="changeFenqi"></div>
              <div class="line" v-if="cameras.length == 1"></div>
              <div
                style="width:31px;height:22px;"
                @click="dbOneVideo"
                v-if="cameras.length == 1"
              >
                <img
                  style="width:100%;height:100%;"
                  src="../../../theme-default/src/images/fangda.png"
                  alt=""
                />
              </div>
            </div>

            <ul class="fenpingBox" v-show="showFenqi">
              <!-- :class="{'martop2':index>4}" -->
              <li
                class="fenping_one martop2"
                v-for="(item, index) in fenping"
                :key="index"
                @click="changeShowType(item.type, index)"
              >
                <img :src="item.src" alt="" />
                <div style="color:#bce1ee;font-size:14px;text-align:center;">
                  {{ item.type }}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="nav-body">
          <div class="video-border">
            <div class="video-wrapper" v-for="(item,index) in cameras" :key="index">
              <VideoMonitorControl
                class="video"
                @spread="cameraSpread"
                :cameraId="item.cameraId"
                :cameraName="item.cameraName"
                autoplay="true"
              />
            </div>
          </div>
        </div> -->
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import ZJApp from "../../../../../app";
const ZJPlayer = ZJApp.ZJPlayer;
const MediaCenter = ZJPlayer.MediaCenter;
const MSG = ZJPlayer.MediaCenterMsg;
// const PageSize = 100;
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
// import VideoMonitorControl from "../../../Components/Component-VideoMonitorControl";
// import VideoMonitorThree from "../../../Components/Component-VideoThree";
import src1 from "../../../theme-default/src/images/1.png";
// import src2 from "../../../theme-default/src/images/2.png";
import src3 from "../../../theme-default/src/images/3.png";
// import src4 from "../../../theme-default/src/images/4.png";
// import src5 from "../../../theme-default/src/images/5.png";
// import src6 from "../../../theme-default/src/images/6.png";
// import src7 from "../../../theme-default/src/images/7.png";
import src8 from "../../../theme-default/src/images/8.png";
// import src9 from "../../../theme-default/src/images/9.png";
// import src10 from "../../../theme-default/src/images/10.png";
// import src11 from "../../../theme-default/src/images/11.png";
// import src12 from "../../../theme-default/src/images/12.png";
// import src13 from "../../../theme-default/src/images/13.png";
// import src14 from "../../../theme-default/src/images/14.png";
// import src15 from "../../../theme-default/src/images/15.png";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
export default {
  name: "PlaybackVideo",
  controller: "UI",
  action: "PlaybackVideo",
  components: {
    // VideoMonitorControl
  },
  data() {
    let beginTime = new Date();
    let endTime = new Date();
    beginTime.setTime(beginTime.getTime() + -1 * 60 * 60 * 1000);
    return {
      PageSize: 100,
      fenping: [
        { type: "1", src: src1 },
        // {"type":"3","src":src2},
        { type: "4", src: src3 },
        // {"type":"4","src":src4},
        // {"type":"6","src":src5},
        // {"type":"6","src":src6},
        // {"type":"7","src":src7},
        { type: "9", src: src8 },
        // {"type":"9","src":src9},
        // {"type":"12","src":src10},
        // {"type":"12","src":src11},
        // {"type":"15","src":src12},
        // {"type":"15","src":src13},
        // {"type":"16","src":src14},
        // {"type":"24","src":src15}
      ],
      isStart: true,
      valueJj: 20,
      valueCircle: 20,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: true,
      },
      // cameraId: '',
      // cameraName: '',
      // selectedTag: 'preview',

      // playbackTimeRange: [ beginTime, endTime ],
      ruleForm: {
        date1: beginTime,
        date2: endTime,
      },
      rules: {
        date1: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        date2: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
        },
      ],
      selectPlayerIndex: 0,
      mc: "",
      showtype: "1", //摆放几个视频
      showtypeIndex: 0,
      treeClickCount: 0,
    };
  },
  created() {
    // this.search();
  },
  mounted() {
    this.$store.dispatch("submitIsShowbg", false);
    this.theme.sidemenu.visiable = false;
    this.mc = new MediaCenter();
    this.mc.on("connected", () => this.onConnected());
    this.mc.on("msg", (e) => this.onRecv(e));
    this.mc.on("error", (e) => this.onError(e));
    this.handleLoad();
    this.logInfo.ActionName = "视频回放查询";
    this.logInfo.LogMessage = "视频回放查询";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "视频回放页面";
    this.addOperationLog();
  },
  destoryed() {
    this.submitIsShowbg(true);
  },
  watch: {
    "ruleForm.date1": function() {
      let date1 = this.ruleForm.date1;
      let date2 = this.ruleForm.date2;
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        this.ruleForm.date2 = "";
        alert("开始时间不能大于结束时间");
        //第一个大
      } else {
        //第二个大
      }
    },
    "ruleForm.date2": function() {
      let date1 = this.ruleForm.date1;
      let date2 = this.ruleForm.date2;
      var oDate1 = new Date(date1);
      var oDate2 = new Date(date2);
      if (oDate1.getTime() > oDate2.getTime()) {
        this.ruleForm.date2 = "";
        alert("开始时间不能大于结束时间");
        //第一个大
      } else {
        //第二个大
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    // 加载设备树
    handleLoad() {
      let that = this;
      this.regions = [];
      this.cameras = [];
      this.loading = true;
      this.loadingText = "加载区域中...";
      if (this.mc.$connected) {
        this.beginGetRegions();
      } else {
        this.mc.connect().then(() => that.beginGetRegions());
      }
    },
    beginGetRegions() {
      // 发送命令：分页获取区域信息
      this.pageNo = 1;
      this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
        pageNo: this.pageNo,
        pageRows: this.PageSize,
      });
    },
    onPlayback() {
      // this.$refs[formName].validate((valid) => {
      //     if (valid) {
      let val1 = this.ruleForm.date1;
      let val2 = this.ruleForm.date2;
      if (val1 && val2) {
        let player = this.$refs.childOneVideo;
        player.play();
      } else {
        console.log(val1);
        console.log(val2);
        if (val1 == "") {
          alert("请选择开始日期时间");
          return;
        } else if (val2 == "") {
          alert("请选择结束日期时间");
          return;
        }
      }
    },
    resetForm() {
      this.ruleForm.date1 = "";
      this.ruleForm.date2 = "";
    },
    dbOneVideo() {
      // 全屏
      this.$refs.childOneVideo.onDblClick();
    },
    startOneVideo() {
      // 开始播放视频
      this.$refs.childOneVideo.play();
    },
    stopOneVideo() {
      // 停止播放视频
      this.$refs.childOneVideo.stop();
    },
    changeShowType(type, index) {
      // 改变视频显示个数
      this.showtype = type;
      this.showtypeIndex = index;
      let showtype = Number(this.showtype);
      // console.log("showtype");
      // console.log(showtype);
      let length = this.cameras.length;
      if (length <= showtype) {
        let num = showtype - length;
        for (let i = 0; i < num; i++) {
          let obj = {
            cameraId: "",
            cameraName: "",
          };
          this.cameras.push(obj);
        }
      } else {
        this.cameras.splice(showtype);
      }
      // console.log("this.cameras")
      // console.log(this.cameras)
      this.showFenqi = false;
    },
    search() {
      let that = this;
      new MyApis.EquipmentApi()
        .GetRegionEquipment({
          EquipmentType: "Monitor",
        })
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.nodes = that.convertToTreeNodesfunction(r);
          console.log("this.nodes");
          console.log(this.nodes);
        })
        .catch((e) => {
          console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = [];
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        var region = {
          id: regionData.RegionId,
          label: regionData.RegionName,
          children: [],
        };

        if (!regionData.Devices) continue;
        for (let j = 0; j < regionData.Devices.length; j++) {
          var deviceData = regionData.Devices[j];
          region.children.push({
            id: deviceData.DeviceId,
            label: deviceData.DeviceName,
            children: [],
          });
        }
        result.push(region);
      }
      // console.log("result")
      // console.log(result)
      return result;
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function(data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          //双击事件
          let showtype = Number(this.showtype);
          if (node.level == 3) {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              this.cameras[this.selectPlayerIndex].cameraId = data.id;
              this.cameras[this.selectPlayerIndex].cameraName = data.label;

              this.selectPlayerIndex = (this.selectPlayerIndex + 1) % showtype;
            }
          }
        }
      }, 300);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
    changeFenqi() {
      this.showFenqi = !this.showFenqi;
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("响应");
      console.log(e);
      const msg = e.data;
      if (msg.isResponse()) {
        switch (msg.msgCode) {
          case MSG.GET_PAGED_REGION_LIST:
            this.onGetRegions(msg.getJsonData());
            break;
          case MSG.GET_PAGED_CAMERA_LIST:
            this.onGetCameras(msg.getJsonData());
            break;
        }
      }
    },
    // 处理获取区域的响应
    onGetRegions(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.regions.push(list[i]);
        }

        if (this.regions.length >= data.total) {
          this.loadingText = "加载区域...100%";
          this.onGetRegionCompleted();
        } else {
          if (data.total > 0) {
            this.loadingText =
              "加载区域..." +
              parseInt((this.regions.length * 100) / data.total) +
              "%";
          }
          // 获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_REGION_LIST, {
            pageNo: this.pageNo,
            pageRows: this.PageSize,
          });
        }
      } else {
        console.error(r && r.msg ? r.msg : "未获取到区域信息");
        this.$message.error("出错了: 无区域信息");
      }
    },

    // 已经获取到所有区域
    onGetRegionCompleted() {
      console.log("onGetRegionCompleted", this.regions);
      // 获取监控点信息
      this.pageNo = 1;
      this.loadingText = "加载监控点...";
      this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
        pageNo: this.pageNo,
        pageRows: this.PageSize,
      });
    },

    // 获取到摄像机
    onGetCameras(r) {
      console.log(r);
      if (r && r.code == "0" && r.data && r.data.list) {
        const data = r.data;
        const list = data.list;
        for (let i = 0; i < list.length; i++) {
          this.cameras.push(list[i]);
        }

        if (this.cameras.length >= data.total) {
          this.loadingText = "加载监控点...100%";
          this.onGetCameraCompleted();
        } else {
          if (data.total > 0) {
            this.loadingText =
              "加载监控点..." +
              parseInt((this.cameras.length * 100) / data.total) +
              "%";
          }
          // 获取下一页
          this.pageNo++;
          this.mc.sendCmd(MSG.GET_PAGED_CAMERA_LIST, {
            pageNo: this.pageNo,
            pageRows: this.PageSize,
          });
        }
      } else {
        console.error(r && r.msg ? r.msg : "未获取到监控点信息");
        this.$message.error("出错了: 无监控点信息");
      }
    },

    // 已经获取到所有摄像机
    onGetCameraCompleted() {
      console.log("onGetCameraCompleted", this.cameras);
      this.buildTree();
    },

    // 构建设备树
    buildTree() {
      const tree = [];
      const regionDic = {};
      const cameraDic = {};
      const expandedKeys = [];

      for (let i = 0; i < this.regions.length; i++) {
        let region = this.regions[i];
        regionDic[region.indexCode] = {
          label: region.name,
          id: region.indexCode,
          parent: region.parentIndexCode,
        };
        expandedKeys.push(region.indexCode);
      }

      for (let i = 0; i < this.regions.length; i++) {
        let region = this.regions[i];
        region = regionDic[region.indexCode];
        if (region.parent) {
          let parent = regionDic[region.parent];
          if (parent) {
            parent.children = parent.children || [];
            parent.children.push(region);
          } else {
            tree.push(region);
          }
        } else {
          tree.push(region);
        }
      }

      console.log(tree);

      const otherRegion = {
        label: "其他",
        id: "other-region",
        parent: null,
        children: [],
      };

      for (let i = 0; i < this.cameras.length; i++) {
        let camera = this.cameras[i];
        cameraDic[camera.cameraIndexCode] = {
          label: camera.cameraName,
          id: camera.cameraIndexCode,
          parent: camera.regionIndexCode,
          isCamera: true,
          cameraType: camera.cameraType,
          cameraTypeName: camera.cameraTypeName,
        };
      }

      for (let i = 0; i < this.cameras.length; i++) {
        let camera = this.cameras[i];
        camera = cameraDic[camera.cameraIndexCode];
        if (camera.parent) {
          let parent = regionDic[camera.parent];
          if (parent) {
            parent.children = parent.children || [];
            parent.children.push(camera);
          } else {
            otherRegion.children.push(camera);
          }
        } else {
          otherRegion.children.push(camera);
        }
      }

      if (otherRegion.children.length > 0) {
        tree.push(otherRegion);
        expandedKeys.push(otherRegion.id);
      }

      console.log(tree);

      this.tree = tree;
      this.expandedKeys = expandedKeys;

      this.loading = false;
    },

    // 点击设备树中的某一个节点
    // handleNodeClick(data) {
    //   if (data && data.isCamera) {
    //     this.cameraId = data.id;
    //     this.cameraName = data.label;
    //     let player = this.selectedTag === 'preview' ? this.$refs.previewPlayer:this.$refs.playbackPlayer;
    //     let autoplay = this.selectedTag === 'preview' ? this.previewPlayerConfigs.autoplay:this.playbackPlayerConfigs.autoplay;
    //     //如果自动播放或者正在播放时，开始播放新选择的监控
    //     if (autoplay || player.isPlaying()) {
    //       player.play();
    //     }
    //   }
    // },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
    this.$store.dispatch("submitIsShowbg", true);
  },
};
</script>

<style scoped>
.leftNav {
  border: 1px solid #00bcfe;
  padding: 28px 20px;
  position: relative;
  background: #003669;
  width: 260px;
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  box-sizing: border-box;
}
.leftSpot {
  width: 222px;
  height: 125px;
  background: url("../../../theme-default/src/images/guangxiao.png") no-repeat;
  position: absolute;
  left: -35px;
  top: -63px;
}
.leftNav_title {
  font-size: 22px;
  font-weight: bold;
  border-bottom: 1px solid #0ec0fe;
  color: #00bcfe;
  height: 60px;
  position: relative;
}
.nav-tree-filter {
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 45px;
  margin-bottom: 20px;
}
.title_btmLine {
  width: 47px;
  height: 7px;
  background-color: #28bbff;
  position: absolute;
  bottom: -3.5px;
  left: 12px;
}
.rightContent {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.bottomContent {
  width: 100%;
  height: 93px;
  background-color: #003669;
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 20px;
  position: relative;
}

/* 选择一个视频 */
.oneVideoBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 1px #00bcfe;
}
.controlOneVideo {
  width: 336px;
  height: 100%;
  background-color: #003669;
  border: solid 1px #00bcfe;
  position: relative;
  margin-left: 30px;
}
.videoOne {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
}
/* 滑块样式 */
.block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.zj_slider {
  width: 220px;
}
/* 选择分屏的样式 */
.changeLogo {
  width: 31px;
  height: 22px;
  background: url("../../../theme-default/src/images/fenping.png") no-repeat;
}
.fenpingBox {
  width: 200px;
  background-color: #003669;
  border: solid 1px #00bcfe;
  position: absolute;
  right: 10px;
  bottom: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  z-index: 10000;
}

.fenping_one {
  list-style: none;
  cursor: pointer;
}
.fenping_one img {
  width: 31px;
  height: 24px;
  margin-bottom: 8px;
}
.martop2 {
  margin-top: 15px;
}
/* 圆盘样式 */
.circleBox {
  width: 238px;
  height: 238px;
  border-radius: 50%;
  border: solid 2px #00bcfe;
  margin: 0 auto;
  margin-top: 40px;
  position: relative;
}
#wrap {
  width: 220px;
  height: 220px;
  position: absolute;
  left: 7px;
  top: 7px;
}
.sector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 220px 110px 110px);
  overflow: hidden;
}
.inner,
.innerSelector {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 110px 220px 0);
  transform: rotate(45deg);
  text-align: left;
  border-radius: 50%;
  /* z-index: 1000; */
}
.inner::before {
  content: url("../../../theme-default/src/images/shang.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
.innerf {
  width: 100%;
  height: 100%;
  position: absolute;
  clip: rect(0 110px 220px 0);
  transform: rotate(90deg);
  text-align: left;
  border-radius: 50%;
  z-index: 1000;
}

.innerf::before {
  content: url("../../../theme-default/src/images/shang.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
.innerSelector::before {
  content: url("../../../theme-default/src/images/shang2.png");
  position: absolute;
  top: 4px;
  right: 99px;
  z-index: 99;
  transform: rotate(-23deg);
}
/* 小圆盘样式 */
.circleMini {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #116ea5;
  border: solid 1px #00bcfe;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -50px;
  margin-top: -50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.fangstop {
  width: 30px;
  height: 30px;
  border-radius: 3px;
  background: #29c7ff;
}
.fangstart {
  width: 23px;
  height: 30px;
  background: url("../../../theme-default/src/images/start.png") no-repeat;
}
/* 三个视频 */
.threes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.leftBigVideo {
  flex: 1;
  height: 100%;
  border: solid 1px #00bcfe;
  margin-right: 20px;
}
.leftVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rightVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.righttopvideo {
  height: 49%;
  width: 49%;
  border: solid 1px #00bcfe;
}
.rightbottomvideo {
  height: 49%;
  width: 100%;
  border: solid 1px #00bcfe;
}
.videoBig-item {
  width: 100%;
  height: 100%;
}
.rightvideo3 {
  height: 32%;
  width: 100%;
  border: solid 1px #00bcfe;
}
/* 6个平分的样式 */
.videoSix {
  width: 49%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.averaBox {
  flex-wrap: wrap;
}
.videoSixtop {
  width: 49%;
  height: 48%;
  border: solid 1px #00bcfe;
}
.videoSixbottom {
  width: 23.5%;
  height: 49%;
  border: solid 1px #00bcfe;
  margin-top: 15px;
}
.rightvideo7 {
  width: 48%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.rightvideo9 {
  width: 32%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.videoNinetop {
  width: 100%;
  height: 48%;
  border: solid 1px #00bcfe;
}
.videoNinebottom {
  width: 49%;
  height: 49%;
  border: solid 1px #00bcfe;
  margin-top: 15px;
}
.rightvideo12 {
  width: 23%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.martop12 {
  margin-top: 10px;
}
.rightvideo15 {
  width: 19%;
  height: 31%;
  border: solid 1px #00bcfe;
}
.rightvideomini {
  width: 15.5%;
  height: 32%;
  border: solid 1px #00bcfe;
}
.rightvideo16 {
  width: 24%;
  height: 24%;
  border: solid 1px #00bcfe;
}
.rightvideo24 {
  width: 15.5%;
  height: 24%;
  border: solid 1px #00bcfe;
}

.zj-demo-player-tree-device-tree .el-tree-node.is-current {
  background-color: rgba(7, 78, 133, 0.7);
}
.changebofang {
  display: flex;
  align-items: center;
  position: absolute;
  left: 39px;
  top: 34px;
}
.line {
  width: 2px;
  height: 26px;
  background: linear-gradient(90deg, #00bcfe 0%, #4ed1ff 100%);
  margin-left: 29px;
  margin-right: 29px;
  opacity: 0.4;
}
.rightChange {
  position: absolute;
  right: 30px;
  top: 34px;
  display: flex;
  align-items: center;
}
.el-date-editor--datetimerange .el-input__inner {
  width: 100%;
}
.dateOutline {
  width: 100%;
  border-radius: 5px;
  border: solid 1px #00bcfe;
}
.searchBtn {
  border-radius: 5px;
  background-color: #2ac1ff;
  width: 100px;
}
.resetBtn {
  border-radius: 5px;
  border: 1px solid #2ac1ff;
  background-color: #01305e;
  width: 100px;
}
</style>
